export default "__VITE_ASSET__BapyeZpF__"